
export interface InstructorPlanDetails {
  id:string;
  name:string;
  pricePerMonth: number,
  pricePerYear: number,
  monthlyEquivalentForYearlyPlan: number,
  upgradeToProDiscount?: number;
  maxCommunityRooms?: number;
  maxCommunityMembers?: number;
  maxCustomPages?: number;
  pricingDetails: {
    monthly: string;
    yearly: string;
  }
}

export const instructorPlans: {[key:string]:InstructorPlanDetails} = {
  growth: {
    id: "growth",
    name: "Free Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    maxCommunityRooms: 1,
    maxCommunityMembers: 1,
    maxCustomPages: 1,
    monthlyEquivalentForYearlyPlan: 0,

    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  basic: {
    id: "basic",
    name: "BASIC Plan",
    pricePerMonth: 29,
    pricePerYear: 290,
    monthlyEquivalentForYearlyPlan: 24,
    maxCommunityRooms: 1,
    maxCommunityMembers: 20,
    maxCustomPages: 1,
    pricingDetails: {
      monthly: "$29/month",
      yearly: "$24/month ($290 billed annually)"
    }
  },
  pro: {
    id: "pro",
    name: "PRO Plan",
    pricePerMonth: 65,
    pricePerYear: 650,
    monthlyEquivalentForYearlyPlan: 54,
    maxCommunityRooms: 3,
    maxCommunityMembers: 100,
    maxCustomPages: 10,
    pricingDetails: {
      monthly: "$65/month",
      yearly: "$54/month ($650 billed annually)"
    }
  },
  unlimited: {
    id: "unlimited",
    name: "UNLIMITED Plan",
    pricePerMonth: 99,
    pricePerYear: 990,
    monthlyEquivalentForYearlyPlan: 82,
    maxCommunityRooms:10000,
    maxCommunityMembers: 10000000,
    maxCustomPages: 10000000,
    pricingDetails: {
      monthly: "$99/month",
      yearly: "$82/month ($990 billed annually)"
    }
  },
  enterprise: {
    id: "enterprise",
    name: "Enterprise Plan",
    pricePerMonth: 129,
    pricePerYear: 1285,
    monthlyEquivalentForYearlyPlan: 107,
    maxCommunityRooms:10000,
    maxCommunityMembers: 10000000,
    maxCustomPages: 10000000,
    pricingDetails: {
      monthly: "$129/month",
      yearly: "$107/month ($1285 billed annually)"
    }
  },
  founder: {
    id: "founder",
    name: "Founder Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    maxCommunityRooms: 3,
    maxCommunityMembers: 10000000,
    maxCustomPages: 10000000,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  lifetime: {
    id: "lifetime",
    name: "Lifetime Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    maxCommunityRooms: 3,
    maxCommunityMembers: 100,
    maxCustomPages: 10,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-basic": {
    id: "lifetime-basic",
    name: "Lifetime Basic Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    maxCommunityRooms: 1,
    maxCommunityMembers: 20,
    maxCustomPages: 1,
    upgradeToProDiscount: 50,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-basic-appsumo": {
    id: "lifetime-basic-appsumo",
    name: "AppSumo Lifetime Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    upgradeToProDiscount: 50,
    maxCommunityRooms: 3,
    maxCommunityMembers: 20,
    maxCustomPages: 1,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-pro": {
    id: "lifetime-pro",
    name: "Lifetime Pro Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    maxCommunityRooms: 3,
    maxCommunityMembers: 100,
    maxCustomPages: 10,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-pro-v2": {
    id: "lifetime-pro-v2",
    name: "AppSumo Lifetime Plan v2",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    maxCommunityRooms: 3,
    maxCommunityMembers: 100,
    maxCustomPages: 10,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },

  "lifetime-pro-v3": {
    id: "lifetime-pro-v3",
    name: "AppSumo Lifetime Plan v3",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    maxCommunityRooms: 3,
    maxCommunityMembers: 100,
    maxCustomPages: 10,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  }


};

export const instructorPlansFrequency: {[key:string]:string} = {
  "monthly": "Monthly",
  "yearly": "Yearly"
}
